import './style.scss';

// ProgrammaCompose Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
    const components = document.querySelectorAll('.booom-programma-compose');

    components.forEach(function(component) {
        // Add your JavaScript functionality here
    });
});
